
import { Component, Vue } from 'vue-property-decorator';
import { ApolloQueryResult } from '@apollo/client';

import { HandleSection } from '@/modules/trade/components/HandleSection';
import { TransactionsSummaryList } from '@/modules/transaction/components/TransactionsSummaryList';
import {
  GetPendingOrdersQuery,
  GetPendingOrdersDocument,
  TradeOrder
} from '@/modules/common/services/graphql/server/server.sdk';
import {
  trackPendingOrderClick,
  trackViewAllPendingOrderClick,
  trackPendingOrdersRequestError,
  trackPendingOrdersRetryClick
} from '@/modules/trade/views/TradeView/trackers';
import { logError } from '@/modules/trade/helpers/logs';

@Component({
  components: {
    HandleSection,
    TransactionsSummaryList
  }
})
export default class PendingOrdersList extends Vue {
  private loading = false;
  private error = false;
  private orders: TradeOrder[] = [];

  private created() {
    this.fetchOrders();
  }

  async handleOnRetry() {
    trackPendingOrdersRetryClick();
    await this.fetchOrders();
  }

  private async fetchOrders() {
    try {
      this.loading = true;
      this.error = false;
      const { data }: ApolloQueryResult<GetPendingOrdersQuery> =
        await this.$apollo.query({
          query: GetPendingOrdersDocument
        });
      this.orders = data!.trade!.orders
        ? (data!.trade!.orders!.orders as unknown as TradeOrder[])
        : [];
    } catch (e) {
      logError(e, 'request_pending_orders');
      trackPendingOrdersRequestError();
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  handleOrderClick() {
    trackPendingOrderClick();
  }

  trackOrdersEvent() {
    trackViewAllPendingOrderClick();
  }

  get showOrders() {
    return this.hasOrders || this.error || this.loading;
  }

  private get hasOrders() {
    return this.orders.length > 0;
  }
}
